module.exports = __webpack_public_path__ + "static/media/cats.fab017e5.jpg";